export default __webpack_public_path__ + "static/signetrings-c14358ddeb4bd5391e0eabba912c7b61.png";